<div class="sign-in">
  <h1>
    {{
      !isRedirectedFromCardsPackages
        ? 'Welcome Back!'
        : 'Please log in to create a PitchCard'
    }}
  </h1>
  <h2 class="mb-4">
    {{
      !isRedirectedFromCardsPackages
        ? 'Enter details below'
        : 'If you don’t have a Pitch59 account, please click Sign Up.'
    }}
  </h2>
  <form (ngSubmit)="doSignIn()" [formGroup]="signInForm" class="input-group">
    <div>
      <label for="email" translate> label_email_address </label>
      <input
        id="email"
        appNoLeadingSpace
        autocomplete="email"
        class="input-primary"
        formControlName="emailId"
        pInputText
        size="30"
        type="text"
      />
    </div>
    <div
      *ngIf="
        signInForm.controls?.emailId?.errors?.required &&
        signInForm.controls?.emailId.touched
      "
      class="error-sign"
      translate
    >
      err_required_emailId
    </div>
    <div
      *ngIf="
        signInForm.controls?.emailId.errors?.pattern &&
        signInForm.controls?.emailId.touched
      "
      class="error-sign"
      translate
    >
      err_invalid_emailId
    </div>
    <div class="mt-2 relative">
      <label for="password" translate>label_password</label>
      <input
        id="password"
        [feedback]="false"
        appNoLeadingSpace
        class="input-primary"
        formControlName="password"
        minlength="3"
        pPassword
        type="password"
      />
      <div
        (click)="togglePassword()"
        *ngIf="showPassword"
        class="sprite eye"
      ></div>
      <div
        (click)="togglePassword()"
        *ngIf="!showPassword"
        class="sprite close-eye"
      ></div>
    </div>
    <div
      *ngIf="
        signInForm.controls?.password.errors?.required &&
        signInForm.controls?.password?.touched
      "
      class="error-sign"
      translate
    >
      err_required_password
    </div>

    <button
      *ngIf="!isHideMainButton"
      [disabled]="isLoading"
      class="button-simple w-full lg-50 shock-pink"
      translate>
      label_sign_in
    </button>
  </form>
  <div class="divider-or" *ngIf="!isHideMainButton">
    <span translate>label_or</span>
  </div>
  <button
    *ngIf="!isHideMainButton"
    type="button"
    class="google-sign-btn"
    (click)="signInWithGoogle()"
  >
    <svg class="google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
    <span translate>label_sign_in_with_google</span>
  </button>
  <button
    *ngIf="!isHideMainButton"
    type="button"
    class="apple-sign-btn"
    (click)="signInWithApple()"
  >
    <svg class="apple-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M16.365 12.822c-.017-1.863 1.522-2.758 1.591-2.8-.868-1.267-2.219-1.441-2.696-1.461-1.148-.116-2.241.676-2.825.676-.586 0-1.494-.659-2.456-.641-1.264.019-2.43.735-3.082 1.872-1.316 2.279-.334 5.65.945 7.499.626.904 1.372 1.919 2.351 1.882.943-.038 1.298-.61 2.439-.61 1.14 0 1.459.61 2.458.591.998-.018 1.629-.904 2.249-1.81.72-1.052 1.016-2.07 1.034-2.123-.022-.01-1.979-.76-2.008-3.085zm-1.448-5.644c.519-.63.869-1.507.773-2.378-.747.03-1.652.498-2.188 1.127-.481.558-.903 1.45-.789 2.302.833.065 1.685-.423 2.204-1.051z"/>
    </svg>
    <span translate>label_sign_in_with_apple</span>
  </button>
  <div class="acc-question mb-2 mt-3">
    Need an account?
    <a (click)="changeActionType('SIGN_UP')" class="sign-up-link underline">
      <b>Sign up</b>
    </a>
  </div>
  <div class="mg-top-5"></div>
  <a
    (click)="changeActionType('RECOVER')"
    class="underline"
    style="color: black"
  >
    <b>Forgot password?</b>
  </a>
</div>
